import { Serializable } from '@admin/core/models/serializable';
export class CustomerStatModel implements Serializable<CustomerStatModel> {
  fromObject(obj: any): CustomerStatModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public totalCount: number;
  public countWithAnnouncements: number;
  public countWithDbProduct: number;
  public countWithSliderProduct: number;
  public countWithCvBoxProduct: number;
}
